// @flow
import type { Saga, Task } from 'redux-saga';

import { call, cancelled } from 'redux-saga/effects';

import sagaMiddleware from '../saga';

export function runWatcherSagaWithErrorBoundaries(saga: () => Saga<any>): Task<void> {
  return sagaMiddleware.run(function* sagaWithErrorBoundaries(): Saga<void> {
    let inLoop = true;
    while (inLoop) {
      try {
        yield call(saga);
      } catch (err) {
        console.error('Saga', err);
      } finally {
        if (yield cancelled()) {
          inLoop = false;
        }
      }
    }
  });
}

export default runWatcherSagaWithErrorBoundaries;



// WEBPACK FOOTER //
// ./src/store/helpers/runWatcherSagaWithErrorBoundaries.js